// POLYFILLS OPTIMIZADOS - Solo para wkx y configuración esencial
// Buffer es requerido por wkx para manejo de geometrías WKT/WKB

// 1. Importar Buffer para wkx
import { Buffer as BufferReal } from 'buffer';

// 2. Configurar globals básicos INMEDIATAMENTE
if (typeof global === 'undefined') {
  window.global = window;
  globalThis.global = window;
}

// // 3. Configurar process INMEDIATAMENTE para variables de entorno
// if (typeof process === 'undefined') {
//   const envVars = {} as Record<string, string>;

//   // Convertir todas las variables de entorno a strings
//   Object.keys(import.meta.env).forEach((key) => {
//     const value = import.meta.env[key];
//     envVars[key] = typeof value === 'string' ? value : String(value);
//   });

//   // Agregar variables de entorno comunes que las librerías pueden necesitar
//   const commonEnvVars = {
//     DEBUG: '', // Para librerías como react-youtube que buscan process.env.DEBUG
//     NODE_DEBUG: '',
//     BABEL_ENV: import.meta.env.MODE || 'production',
//     // Variables de desarrollo comunes
//     VITE_DEBUG: '',
//     VITE_NODE_ENV: import.meta.env.MODE || 'production'
//   };

//   const processPolyfill = {
//     env: {
//       NODE_ENV: import.meta.env.MODE || 'production',
//       PUBLIC_URL: '',
//       ...commonEnvVars,
//       ...envVars
//     } as NodeJS.ProcessEnv,
//     browser: true,
//     version: '16.0.0',
//     platform: 'darwin' as NodeJS.Platform,
//     nextTick: (fn: any) => setTimeout(fn, 0) as any,
//     cwd: () => '/',
//     argv: []
//   } as Partial<NodeJS.Process>;

//   (window as any).process = processPolyfill;
//   (global as any).process = processPolyfill;
//   (globalThis as any).process = processPolyfill;
// }

// 4. CRÍTICO: Configurar Buffer para wkx (geometrías WKT/WKB)
window.Buffer = BufferReal;
global.Buffer = BufferReal;
globalThis.Buffer = BufferReal;

// 5. Verificar que Buffer funciona correctamente para wkx
console.log('🔧 Verificando Buffer polyfill para wkx...');
try {
  const testBuffer = BufferReal.alloc(4);
  testBuffer.writeUInt8(255, 0);
  console.log('✅ Buffer polyfill funciona correctamente para wkx:', {
    writeUInt8: typeof testBuffer.writeUInt8,
    instance: testBuffer.constructor.name
  });
} catch (error) {
  console.error('❌ Error en Buffer polyfill:', error);
  throw new Error('Buffer polyfill failed - wkx no funcionará correctamente');
}

// 3. Verificar si React DevTools está disponible - método seguro
try {
  // Solo configurar si realmente no existe o si podemos modificarlo
  if (typeof globalThis.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
    globalThis.__REACT_DEVTOOLS_GLOBAL_HOOK__ = { isDisabled: true };
  }
} catch (error) {
  // Si no podemos configurar globalThis, no es crítico
  console.log('React DevTools ya está configurado en globalThis');
}

try {
  // Verificar si podemos configurar en window
  const descriptor = Object.getOwnPropertyDescriptor(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__');
  if (!descriptor) {
    // No existe, podemos crear la propiedad
    (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ = { isDisabled: true };
  } else if (descriptor.writable || descriptor.set) {
    // Existe pero es escribible, podemos modificarlo si es necesario
    console.log('React DevTools ya está configurado en window (escribible)');
  } else {
    // Existe como getter/setter o no escribible, no podemos modificarlo
    console.log('React DevTools ya está configurado en window (solo lectura)');
  }
} catch (error) {
  // Si falla, React DevTools probablemente ya está configurado
  console.log('React DevTools ya está configurado en window');
}

console.log('✅ React DevTools polyfill configurado de forma segura');

// 4. Verificación específica para entorno de producción
if (import.meta.env.MODE === 'production' || import.meta.env.PROD) {
  // Asegurar que React esté disponible globalmente en producción
  try {
    if (typeof window !== 'undefined') {
      // Verificar que React y ReactDOM estén disponibles
      const React = await import('react');
      const ReactDOM = await import('react-dom/client');

      // Hacer React disponible globalmente si no lo está
      if (!(window as any).React) {
        (window as any).React = React;
      }
      if (!(window as any).ReactDOM) {
        (window as any).ReactDOM = ReactDOM;
      }

      // CRÍTICO: Configurar JSX runtime específicamente para producción
      try {
        const jsxRuntime = await import('react/jsx-runtime');
        (window as any).__jsx = jsxRuntime.jsx;
        (window as any).__jsxs = jsxRuntime.jsxs;
        (window as any).__Fragment = jsxRuntime.Fragment;
        console.log('✅ JSX runtime configurado correctamente para producción');
      } catch (jsxError) {
        console.warn('⚠️ No se pudo importar JSX runtime específico:', jsxError);
        // Fallback: usar React.createElement
        (window as any).__jsx = React.createElement;
        (window as any).__jsxs = React.createElement;
        (window as any).__Fragment = React.Fragment;
      }

      console.log('✅ React configurado globalmente para producción');
    }
  } catch (error) {
    console.warn('⚠️ Error configurando React globalmente:', error);
  }
}

// 5. Asegurar que webpack no cause problemas
if (typeof window !== 'undefined') {
  (window as any).__webpack_require__ =
    (window as any).__webpack_require__ ||
    function (id: string) {
      console.warn(`Module ${id} not found in polyfill, returning empty object`);
      return {};
    };
}

console.log('🎉 Polyfills optimizados cargados exitosamente (Buffer para wkx)');

export {};
